import "../styles/process.scss";
import { logos, items } from "../services/data.ts";
const Process = () => {
    const steps = items.steps
    return (
        <section class="process">
            <h5 class="subtitle">PROCESSO</h5>
            <h2>Como funciona?</h2>
            <p>Pode fazer acompanhamento de todo o processo através da plataforma online.</p>
            <p className="know">
                <a href="/etapas">
                    Saiba mais
                    </a>
                <img src={logos.arrow_up} />
            </p>
            <div class="processline">
                {items.steps.map((step, index) => (
                <div class="step">
                    <div class="circle">{index+1}</div>
                    <p>{step.title}</p>
                </div>
            ))}
            </div>
        </section>

    )
}
export default Process